// @ts-nocheck
import React, { useEffect, useState } from 'react';

import axios from 'axios';

import ORG_MIDAR_LOGO from 'assets/midar_logo.png';
import ORG_MODON_LOGO from 'assets/modon_logo.png';

const CAIRO_FONT = 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap';
// const ORG_LOGO = 'https://www.midar.org/images/logo@2x.png';

const ORG_LOGOS: Record<string, string> = {
  mwasalat_modon_misr: ORG_MODON_LOGO,
  midar: ORG_MIDAR_LOGO,
};

const ERROR_MESSAGES = {
  incomplete: 'عذراً، هذا الرابط غير صالح أو ناقص. يرجى مسح الكود مرة أخرى أو التواصل مع السائق.',
  notFound:   'لم يتم العثور على بيانات هذه التذكرة. تأكد أن الكود صحيح أو تواصل مع الدعم.',
  network:    'لا يوجد اتصال بالإنترنت. تحقق من الاتصال وأعد المحاولة.',
  server:     'حدث خطأ في النظام. يرجى المحاولة مرة أخرى بعد قليل.',
  unknown:    'حدث خطأ غير متوقع. يرجى مسح الكود مرة أخرى أو التواصل مع الدعم.',
};

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    background: '#f0f4f8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    fontFamily: "'Cairo', 'Segoe UI', Arial, sans-serif",
    direction: 'rtl',
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
    width: '100%',
    maxWidth: '420px',
    overflow: 'hidden',
    direction: 'rtl',
    fontFamily: "'Cairo', 'Segoe UI', Arial, sans-serif",
  },
  header: {
    background: 'transparent',
    borderBottom: '1px solid #e2e8f0',
    padding: '20px 24px 16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
  },
  logo:        { height: '56px', width: 'auto', maxWidth: '160px', objectFit: 'contain' },
  headerTitle: { margin: 0, color: '#1a202c', fontSize: '1.15rem', fontWeight: 700, textAlign: 'center' },
  body:        { padding: '20px 24px' },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
  },
  rowLabel: { color: '#718096', textAlign: 'right' },
  rowValue: { textAlign: 'left' },
  divider:  { border: 'none', borderTop: '1px solid #e2e8f0', margin: '8px 0' },
  stateBox: { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '28px 24px' },
  stateIcon: { fontSize: '2rem', marginBottom: '8px' },
  stateText: { margin: '2px 0', textAlign: 'center', color: '#4a5568', fontSize: '0.95rem' },
  errorBox: { background: '#fff5f5', borderRadius: '12px', margin: '16px' },
};

const getFontSize = (small: boolean, large: boolean, smSize: string, lgSize: string, base: string) => {
  if (small) return smSize;
  if (large) return lgSize;

  return base;
};

const formatDateTime = (epochSeconds: number) => {
  if (!epochSeconds) return '—';

  try {
    const date = new Date(epochSeconds * 1000);

    const datePart = date.toLocaleDateString('ar-EG', {
      timeZone: 'Africa/Cairo',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    const timePart = date.toLocaleTimeString('ar-EG', {
      timeZone: 'Africa/Cairo',
      hour: '2-digit',
      minute: '2-digit',
    });

    // Joined manually so the locale's "في" separator is not added
    return `${datePart} - ${timePart}`;
  } catch (_e) {
    return '—';
  }
};

const Divider = () => <hr style={styles.divider} />;

const Row = ({ label, value, small = false, large = false, valueColor = '#1a202c' }) => (
  <div style={styles.row}>
    <span style={{ ...styles.rowLabel, fontSize: getFontSize(small, large, '0.82rem', '1rem', '0.9rem') }}>
      {label}
    </span>

    <span style={{ ...styles.rowValue, fontSize: getFontSize(small, large, '0.85rem', '1.1rem', '0.95rem'), color: valueColor, fontWeight: large ? 700 : 500 }}>
      {value || '—'}
    </span>
  </div>
);

const TicketingInquiry: React.FC = () => {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState<string | null>(null);

  useEffect(() => {
    if (!document.querySelector(`link[href="${CAIRO_FONT}"]`)) {
      const link = document.createElement('link');

      link.rel  = 'stylesheet';
      link.href = CAIRO_FONT;
      document.head.appendChild(link);
    }
  }, []);

  useEffect(() => {
    const params        = new URLSearchParams(window.location.search);
    const base_fare     = params.get('b') || params.get('base_fare');
    const axis_id       = params.get('a') || params.get('axis_id');
    const ticket_serial = params.get('t') || params.get('ticket_serial');

    if (!base_fare || !axis_id || !ticket_serial) {
      setError(ERROR_MESSAGES.incomplete);
      setLoading(false);

      return;
    }

    const requestParams: any = { b: base_fare, a: axis_id, t: ticket_serial };
    if (params.get('org_code')) {
      requestParams.org_code = params.get('org_code');
    }

    axios
      .get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/public/ticketing/inquiry`, {
        params: requestParams,
      })
      .then(res => {
        setData(res.data?.data);
        setLoading(false);
      })
      .catch(err => {
        if (!err.response) {
          setError(ERROR_MESSAGES.network);
        } else if (err.response.status === 404) {
          setError(ERROR_MESSAGES.notFound);
        } else if (err.response.status >= 500) {
          setError(ERROR_MESSAGES.server);
        } else {
          setError(ERROR_MESSAGES.unknown);
        }

        setLoading(false);
      });
  }, []);

  const fmt = (val: any) =>
    val !== null && val !== undefined ? Number(val).toFixed(2) : '—';

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        <div style={styles.header}>
          <img
            src={ORG_LOGOS[data?.org_code] || ORG_MODON_LOGO}
            alt="شعار المنظمة"
            style={styles.logo}
            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
          />

          <h2 style={styles.headerTitle}>تفاصيل التذكرة</h2>
        </div>

        {loading && (
          <div style={styles.stateBox}>
            <span style={styles.stateIcon}>⏳</span>

            <p style={styles.stateText}>جارٍ تحميل بيانات التذكرة...</p>
          </div>
        )}

        {error && (
          <div style={{ ...styles.stateBox, ...styles.errorBox }}>
            <span style={styles.stateIcon}>⚠️</span>

            <p style={{ ...styles.stateText, color: '#c53030', fontWeight: 600 }}>تعذّر تحميل التذكرة</p>

            <p style={{ ...styles.stateText, color: '#744210', fontSize: '0.85rem', marginTop: 4 }}>{error}</p>
          </div>
        )}

        {data && !loading && (
          <div style={styles.body}>
            <Row label="الاتجاة" value={data.axis_ar_name} />

            <Row label="رقم التذكرة" value={data.ticket_serial_appear_to_user} small />

            {data.is_card && data.fare_media_serial_num && (
              <Row label="رقم الكارت" value={data.fare_media_serial_num} small />
            )}

            <Row label="تاريخ ووقت التذكرة" value={formatDateTime(data.obc_time)} small />

            <Divider />

            <Row label="السعر الأساسي" value={`${fmt(data.base_fare)} ج.م`} />

            {Number(data.discount_applied) > 0
              ? (
                <>
                  <Row label="الخصم المطبّق" value={`- ${fmt(data.discount_applied)} ج.م`} valueColor="#276749" />

                  <Row label="اسم العرض" value={data.applied_discount_band_name} small />

                  <Row label="كود العرض" value={data.applied_discount_band_code} small />
                </>
              )
              : <Row label="الخصم" value="لا يوجد خصم" small />
            }

            <Divider />

            <Row
              label="المبلغ المدفوع"
              value={`${fmt(data.amount_after_discount)} ج.م`}
              large
              valueColor="#2b6cb0"
            />

            {data.is_card && (
              <div style={{
                marginTop: '16px',
                textAlign: 'center',
                color: 'black',
                fontSize: '0.95rem',
                fontWeight: 500,
                lineHeight: '1.5'
              }}>
                رجاء مراجعة تطبيق المحمول خلال ٢٤ ساعة لمعرفة الرصيد النهائي
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

export default TicketingInquiry;
